/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ChardiService } from './services/chardi.service';
import { ChargingConfigurationService } from './services/charging-configuration.service';
import { ChargingSessionsService } from './services/charging-sessions.service';
import { OcppOperationService } from './services/ocpp-operation.service';
import { ParkingPlaceService } from './services/parking-place.service';
import { ParkingSpotService } from './services/parking-spot.service';
import { UsersService } from './services/users.service';
import { WeightingService } from './services/weighting.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ChardiService,
    ChargingConfigurationService,
    ChargingSessionsService,
    OcppOperationService,
    ParkingPlaceService,
    ParkingSpotService,
    UsersService,
    WeightingService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
